export const SKIP_TARGET_ID = 'main-content'

export function SkipToMainContentTarget() {
  return <div id={SKIP_TARGET_ID} tabIndex={-1} aria-hidden="true" />
}
